__turbopack_context__.v({
  "contactSlot": "ContactButton-module-scss-module__ZzZolG__contactSlot",
});
